// src/components/TransportMarkerList.js
import React, { useEffect, useState } from 'react';
/* global axios */
import api from '../services/apiService';


function TransportMarkerList() {
  // -----------------------
  // State für Orders & Auswahl
  // -----------------------
  const [orders, setOrders] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState('');

  // -----------------------
  // State für OrderItems (die zu selectedOrderId gehören)
  // -----------------------
  const [orderItems, setOrderItems] = useState([]);

  // -----------------------
  // State für TransportMarker
  // -----------------------
  const [transportMarkers, setTransportMarkers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // -----------------------
  // States fürs Erstellen/Bearbeiten
  // -----------------------
  const [showForm, setShowForm] = useState(false);
  const [editMode, setEditMode] = useState(false);

  // currentMarker repräsentiert das, was wir gerade im Formular bearbeiten
  const [currentMarker, setCurrentMarker] = useState({
    id: null,
    orderItemId: '',
    delivery: '',
    pickup: '',
  });


   // -----------------------
  // State für LW Operators
  // -----------------------
  const [lwOperators, setLwOperators] = useState([]);

  // ==========================================================================
  // 1) Beim ersten Render: Alle Orders laden und alle TransportMarker laden
  // ==========================================================================
  useEffect(() => {
    fetchAllOrders();
    fetchTransportMarkers();
    fetchLwOperators(); // LW Operators laden
  }, []);

  // ==========================================================================
  // 2) Immer wenn sich selectedOrderId ändert, OrderItems laden
  // ==========================================================================
  useEffect(() => {
    if (selectedOrderId) {
      fetchOrderItems(selectedOrderId);
    } else {
      setOrderItems([]); // nichts ausgewählt -> leere Liste
    }
  }, [selectedOrderId]);

  // --------------------------------------------------------------------------
  // 3) API-Funktionen
  // --------------------------------------------------------------------------

  // 3.1) Orders laden
  const fetchAllOrders = async () => {
    try {
      const response = await api.get('/orders'); // baseURL wird automatisch vorangestellt
      console.log("Fetched Orders:", response.data); // Debug: Axios liefert die Daten in response.data
      setOrders(response.data);
    } catch (err) {
      console.error('Fehler beim Laden der Orders:', err);
      alert('Fehler beim Laden der Orders');
    }
  };

  // 3.2) OrderItems laden
  const fetchOrderItems = async (orderId) => {
  try {
    const { data } = await api.get(`/orders/${orderId}/orderitems/rental`);
    setOrderItems(data || []);
  } catch (e) {
    if (e?.response?.status === 404) { setOrderItems([]); return; }
    console.error('Fehler beim Laden der OrderItems:', e);
    alert('Fehler beim Laden der OrderItems');
  }
};

  // 3.3) TransportMarker laden
  const fetchTransportMarkers = async () => {
    setIsLoading(true);
    try {
      // Verwende den relativen Pfad; der baseURL wird automatisch vorangestellt
      const response = await api.get('/transportmarkers');
      console.log("Fetched TransportMarkers:", response.data); // Axios liefert die Daten in response.data
      setTransportMarkers(response.data);
    } catch (err) {
      console.error("Fehler beim Laden der TransportMarker:", err);
      alert("Fehler beim Laden der TransportMarker");
    } finally {
      setIsLoading(false);
    }
  };

  // 3.4) TransportMarker erstellen
  const createMarker = async (markerData) => {
    try {
      // Axios: Der relative Pfad wird an den baseURL angehängt
      const response = await api.post('/transportmarkers', markerData, {
        headers: { 'Content-Type': 'application/json' }
      });
      alert('TransportMarker erfolgreich erstellt!');
      // Liste aktualisieren, wenn fetchTransportMarkers entsprechend angepasst ist
      await fetchTransportMarkers();
    } catch (error) {
      console.error('Fehler beim Erstellen des TransportMarkers:', error);
      alert('Fehler beim Erstellen des TransportMarkers');
    }
  };

  // 3.5) TransportMarker updaten
  const updateMarker = async (markerId, markerData) => {
    try {
      // Der relative Pfad wird an den in der Axios-Konfiguration definierten baseURL angehängt
      const response = await api.put(`/transportmarkers/${markerId}`, markerData, {
        headers: { 'Content-Type': 'application/json' }
      });
      alert('TransportMarker erfolgreich aktualisiert!');
      // Liste aktualisieren
      await fetchTransportMarkers();
    } catch (error) {
      console.error('Fehler beim Aktualisieren des TransportMarkers:', error);
      alert('Fehler beim Aktualisieren des TransportMarkers');
    }
  };

  // 3.6) TransportMarker löschen
  const deleteMarker = async (markerId) => {
    const confirmDelete = window.confirm(
      `Möchtest du den TransportMarker #${markerId} wirklich löschen?`
    );
    if (!confirmDelete) return;
  
    try {
      // Axios: Der relative Pfad wird automatisch mit dem baseURL kombiniert
      await api.delete(`/transportmarkers/${markerId}`);
      alert('TransportMarker erfolgreich gelöscht!');
      await fetchTransportMarkers();
    } catch (error) {
      console.error('Fehler beim Löschen des TransportMarkers:', error);
      alert('Fehler beim Löschen des TransportMarkers');
    }
  };

  // 3.7) LW Operators laden
  const fetchLwOperators = async () => {
    try {
      // Der relative Pfad wird automatisch an den baseURL angehängt
      const response = await api.get('/contacts');
      console.log("Fetched LW Operators:", response.data); // Debug: Axios liefert die Daten in response.data
      setLwOperators(response.data);
    } catch (err) {
      console.error('Fehler beim Laden der LW Operators:', err);
      alert('Fehler beim Laden der LW Operators');
    }
  };

  // ==========================================================================
  // 4) Handlers für Buttons & Formular
  // ==========================================================================
  // 4.1) OrderDropdown-Änderung
  const handleOrderSelectChange = (e) => {
    setSelectedOrderId(e.target.value);
  };

  // 4.2) "Neuen Marker erstellen" Button
  const handleOpenFormCreate = () => {
    if (!selectedOrderId) {
      alert('Bitte zuerst eine Order auswählen!');
      return;
    }
    setEditMode(false);
    setCurrentMarker({
      id: null,
      orderItemId: '',
      delivery: '',
      pickup: '',
    });
    setShowForm(true);
  };

  // 4.3) "Bearbeiten" Button
  const handleOpenFormEdit = (marker) => {
    setEditMode(true);
    if (marker.orderItem && marker.orderItem.order) {
        setSelectedOrderId(marker.orderItem.order.id); // Setze die ausgewählte OrderId
      }
    setCurrentMarker({
      id: marker.id,
      orderItemId: marker.orderItem ? marker.orderItem.id : '',
      delivery: marker.delivery ? marker.delivery.substring(0, 16) : '',
      pickup: marker.pickup ? marker.pickup.substring(0, 16) : '',
    });
    setShowForm(true);
  };

  // 4.4) Formular-Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { id, orderItemId, delivery, pickup } = currentMarker;

    // Minimal-Check: OrderItem muss gewählt sein
    if (!orderItemId) {
      alert('Bitte ein OrderItem auswählen!');
      return;
    }

    // Optional: Weitere Validierungen, z.B. Datumskonsistenz
    if (delivery && pickup && new Date(delivery) > new Date(pickup)) {
      alert('Das Lieferdatum muss vor dem Abholdatum liegen.');
      return;
    }

    const markerData = {
      orderItemId,
      delivery: delivery ? delivery : null, // Direkt senden ohne Konvertierung
        pickup: pickup ? pickup : null,
    };

    if (editMode && id) {
      await updateMarker(id, markerData);
    } else {
      await createMarker(markerData);
    }

    setShowForm(false);
  };

  // 4.5) Controlled Inputs im Formular
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentMarker((prev) => ({ ...prev, [name]: value }));
  };

  // ==========================================================================
  // 5) Render
  // ==========================================================================
  // Filterung der TransportMarker basierend auf ausgewählten OrderItems
  const filteredTransportMarkers = transportMarkers.filter(marker =>
    orderItems.some(item => item.id === marker.orderItemId)
  );

  // Finden der ausgewählten Order
  const selectedOrder = orders.find(order => order.id === parseInt(selectedOrderId));
  console.log("Selected Order:", selectedOrder); // Debug

  return (
    <div style={{ padding: '1rem' }}>
      <h2>TransportMarker-Verwaltung</h2>

      {/* ----------------- Dropdown für Orders ----------------- */}
      <label>
        Auftrag auswählen:
        <select
          value={selectedOrderId}
          onChange={handleOrderSelectChange}
          style={{ marginLeft: 8 }}
        >
          <option value="">-- Bitte wählen --</option>
          {orders.map((o) => (
            <option key={o.id} value={o.id}>
              {/* Zeige hier z.B. den Auftragsnamen/Nummer */}
              {o.orderNumber ? `${o.orderNumber} (ID ${o.id})` : `Order #${o.id}`}
            </option>
          ))}
        </select>
      </label>

      <div style={{ marginTop: '1rem' }}>
        <button onClick={handleOpenFormCreate}>Neuen Marker erstellen</button>
      </div>

      {isLoading && <p>Lade TransportMarker-Daten...</p>}

      {!isLoading && filteredTransportMarkers.length === 0 && (
        <p>Keine TransportMarker für die ausgewählte Order vorhanden.</p>
      )}

      {/* ----------------- Liste der TransportMarker ----------------- */}
      {!isLoading && filteredTransportMarkers.length > 0 && (
        <table border="1" cellPadding="6" style={{ marginTop: '1rem', width: '100%' }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Order Number</th>
              <th>Customer Company</th>
              <th>OrderItem Name</th>
              <th>LW Operator</th>
              <th>Delivery</th>
              <th>Pickup</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {filteredTransportMarkers.map((marker) => {
              const order = marker.orderItem ? marker.orderItem.order : null;
              const customer = order ? order.customer : null;
              const lwOperator = order ? order.lwOperator : null;
              const item = marker.orderItem ? marker.orderItem.item : null;
              return (
                <tr key={marker.id}>
                  <td>{marker.id}</td>
                  <td>{order ? order.orderNumber : '–'}</td> 
                  <td>{customer ? customer.company : '–'}</td> 
                  <td>{item ? item.name : '–'}</td> 
                  <td>{lwOperator ? `${lwOperator.contactFirstName} ${lwOperator.contactLastName}` : '–'}</td> 
                  <td>
  {marker.delivery
    ? new Date(marker.delivery).toLocaleString('de-DE', {
        timeZone: 'Europe/Berlin',
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        
      })
    : '–'}
</td>
<td>
  {marker.pickup
    ? new Date(marker.pickup).toLocaleString('de-DE', {
        timeZone: 'Europe/Berlin',
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        
      })
    : '–'}
</td>
                  <td>
                    <button onClick={() => handleOpenFormEdit(marker)}>Bearbeiten</button>{' '}
                    <button onClick={() => deleteMarker(marker.id)}>Löschen</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {/* ----------------- Formular zum Erstellen/Bearbeiten ----------------- */}
      {showForm && (
        <div style={{ marginTop: '1rem', border: '1px solid #ccc', padding: '1rem' }}>
          <h3>{editMode ? 'TransportMarker bearbeiten' : 'Neuen TransportMarker erstellen'}</h3>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {/* Wenn im Bearbeitungsmodus, zeige OrderItem, Customer Company und Order Number als read-only Felder */}
            {editMode && (
              <>
                <label>
                  Order Number:
                  <input
                    type="text"
                    name="orderNumber"
                    value={
                      transportMarkers.find(marker => marker.id === currentMarker.id)?.orderItem?.order?.orderNumber || ''
                    }
                    readOnly
                  />
                </label>

                <label>
                  Customer Company:
                  <input
                    type="text"
                    name="customerCompany"
                    value={
                      transportMarkers.find(marker => marker.id === currentMarker.id)?.orderItem?.order?.customer?.company || ''
                    }
                    readOnly
                  />
                </label>

                <label>
                  OrderItem Name:
                  <input
                    type="text"
                    name="orderItemName"
                    value={
                      transportMarkers.find(marker => marker.id === currentMarker.id)?.orderItem?.item?.name || ''
                    }
                    readOnly
                  />
                </label>
              </>
            )}

            {/* Wenn nicht im Bearbeitungsmodus, füge ein Dropdown hinzu, um OrderItem auszuwählen */}
            {!editMode && (
              <label>
                OrderItem:
                <select
                  name="orderItemId"
                  value={currentMarker.orderItemId}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Bitte wählen --</option>
                  {orderItems.map((item) => (
                    <option key={item.id} value={item.id}>
                      {/* Zeige hier z.B. den Namen oder Beschreibung */}
                      {item.item ? `${item.item.name} (ID ${item.id})` : `Item #${item.id}`}
                    </option>
                  ))}
                </select>
              </label>
            )}

           

<label>
  Delivery:
  <input
    type="date"
    name="delivery"
    value={currentMarker.delivery ? currentMarker.delivery.split('T')[0] : ''}
    onChange={handleChange}
  />
</label>

<label>
  Pickup:
  <input
    type="date"
    name="pickup"
    value={currentMarker.pickup ? currentMarker.pickup.split('T')[0] : ''}
    onChange={handleChange}
  />
</label>

            <div>
              <button type="submit">{editMode ? 'Speichern' : 'Erstellen'}</button>{' '}
              <button type="button" onClick={() => setShowForm(false)}>
                Abbrechen
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default TransportMarkerList;
